import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { translate } from "../translations";
import { partners } from "../data/partners";

function Partners() {
  const { language } = useLanguage();
  const hasPartners = partners && partners.length > 0;

  return (
    <section id="partners" className="partners-section">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">
            {translate("partnersBadge", language)}
          </span>
          <h2 className="section-title">
            {translate("partnersTitle", language)}
          </h2>
          <p className="section-description">
            {translate("partnersDescription", language)}
          </p>
        </div>
        {hasPartners ? (
        <div className="partners-grid">
          {partners.map((partner) => {
            const isTransparentLogo = partner.logo && partner.logo.includes("siclade");
            const content = (
              <div className="partner-logo-wrap">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className={`partner-logo ${isTransparentLogo ? "partner-logo--transparent" : ""}`}
                />
              </div>
            );
            if (partner.url) {
              return (
                <a
                  key={partner.id}
                  href={partner.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="partner-card"
                >
                  {content}
                </a>
              );
            }
            return (
              <div key={partner.id} className="partner-card">
                {content}
              </div>
            );
          })}
        </div>
        ) : (
          <p className="partners-empty">
            {translate("partnersEmpty", language)}
          </p>
        )}
      </div>
    </section>
  );
}

export default Partners;
